import axios, { AxiosRequestConfig } from 'axios'
import { AuthResponseDto } from '@sparling/financial-common'

export const loginUser = async (
  { username, password }: { username: string; password: string },
  options: AxiosRequestConfig = {},
): Promise<AuthResponseDto> => {
  const response = await axios.post<AuthResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/login`,
    { username, password },
    {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}

export const login2FAUser = async (
  { token, twoFaCode }: { token: string; twoFaCode: string },
  options: AxiosRequestConfig = {},
): Promise<AuthResponseDto> => {
  const response = await axios.post<AuthResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/2fa/authenticate`,
    { twoFaCode },
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}

export const logoutUser = async (
  { token }: { token: string },
  options: AxiosRequestConfig = {},
): Promise<{ code: number; status: string; message: string }> => {
  const response = await axios.post<{ code: number; status: string; message: string }>(
    `${process.env.REACT_APP_REST_API_URL}/logout`,
    {},
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}
